const Toggle = ({
  value: active,
  disabled,
  activeColor,
  activeTrackColor,
  onChange
}: {
  value: boolean;
  disabled?: boolean;
  activeColor?: string;       // color of the sliding circle when active
  activeTrackColor?: string;  // bg color of the track when active
  onChange: (value: boolean) => void;
}) => {
  const trackBg = active
    ? activeTrackColor || (activeColor ? activeColor : undefined)
    : undefined;

  return (
    <button
      type="button"
      className={
        "relative h-6 w-12 rounded-full transition " +
        (!activeColor && !activeTrackColor && active ? "bg-ctb-blue-550 " : "") +
        (!active ? "bg-slate-300 " : "") +
        (disabled ? " grayscale" : "")
      }
      style={trackBg && active ? { backgroundColor: trackBg } : undefined}
      onClick={() => onChange(!active)}
      disabled={disabled}
    >
      <span
        className={
          "absolute left-1 top-1 aspect-square h-4 rounded-full transition " +
          (active ? "translate-x-6" : "translate-x-0")
        }
        style={{
          backgroundColor: active && activeColor ? activeColor : "#FFFFFF",
          boxShadow: "0 1px 4px rgba(0,0,0,0.30)",
        }}
      />
    </button>
  );
};

export default Toggle;
